/** @type {Styles} */

export const styles = {
  container: {
    justifyContent: 'space-between',
    alignItems: 'center',
    display: 'flex',
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: 2,
    paddingLeft: 3,
    boxSizing: 'border-box',
    height: 64,
    borderBottomWidth: 1,
    borderBottomColor: (theme) => theme.palette.custom.table.main,
    borderBottomStyle: 'solid',
  },
  containerWithIcon: {
    paddingLeft: 3,
  },
  navigation: { display: 'flex', alignItems: 'center' },
  titleIcon: { marginRight: 2, color: 'gray.56' },
  titleAvatar: {
    marginRight: '16px',
  },
  closeAndEdit: { display: 'flex', justifyContent: 'flex-end' },
  editIcon: { display: 'flex', marginY: 0, marginRight: 2, marginLeft: 1 },
  cancel: {
    marginRight: 1,
    '& .MuiButton-root': {
      color: 'primary.main',
    },
  },
  backButton: {
    fontWeight: 600,
    '&.MuiButton-root': {
      lineHeight: 1.75,
    },
  },
  title: {
    maxWidth: 450,
  },
}
